import React from 'react';

import {useStore} from 'effector-react';

import {
    CUSTOMS_NAVIGATION_LINKS,
    LinkData,
    NAVIGATION_LINKS,
    NavigationLinksShowEnum,
} from 'core/navigationLinks';

import {ROUTE} from 'core/routes';

import {isAdmin$, isCustomsDirector$, isCustomsRole$} from 'models/auth';

import {MenuIcon, MenuItem, MenuItemTitle, SidebarMenu} from './styled';

interface Props {
    isMobile?: boolean;
    onClickHandler?: Function;
}

export function SidebarNavigation({isMobile, onClickHandler = () => {}}: Props) {
    const isAdmin = useStore(isAdmin$);
    const isCustomsRole = useStore(isCustomsRole$);
    const isCustomsDirector = useStore(isCustomsDirector$);

    const EXTRA_ACTIVE_PATH_FOR_DOCUMENTS = {
        [ROUTE.DOCUMENTS_DOCUMENTS]: true,
        [ROUTE.DOCUMENTS_INVOICES]: true,
        [ROUTE.DOCUMENTS_CHECKS]: true,
        [ROUTE.DOCUMENTS_INVOICES_INCOMING]: true,
        [ROUTE.DOCUMENTS_INVOICES_OUTGOING]: true,
        [ROUTE.DOCUMENTS_GDS]: true,
        [ROUTE.DOCUMENTS_GDS_CREATE]: true,
    };

    const NAVIGATION_MAP: {
        DEFAULT: LinkData[];
        CUSTOMS_DIRECTOR: LinkData[];
        CUSTOMS_EMPLOYEE: LinkData[];
    } = {
        CUSTOMS_DIRECTOR: CUSTOMS_NAVIGATION_LINKS,
        CUSTOMS_EMPLOYEE: CUSTOMS_NAVIGATION_LINKS.filter(
            (link) => link.route !== ROUTE.DOCUMENTS_DOCUMENTS,
        ),
        DEFAULT: NAVIGATION_LINKS.filter((link) => {
            if (link.route === ROUTE.DECLARATIONS) {
                return isAdmin;
            }
            return true;
        }),
    };

    const ROLE = isCustomsRole
        ? isCustomsDirector
            ? 'CUSTOMS_DIRECTOR'
            : 'CUSTOMS_EMPLOYEE'
        : 'DEFAULT';

    const NAVIGATION = NAVIGATION_MAP[ROLE] ?? NAVIGATION_MAP.DEFAULT;

    const links = NAVIGATION.filter(
        (link) => link.showOn !== NavigationLinksShowEnum[isMobile ? 'desktop' : 'mobile'],
    );

    return (
        <SidebarMenu>
            {links.map((item, index) => (
                <MenuItem
                    to={item.route}
                    key={index}
                    isActive={(match: any, location) =>
                        (item.route === ROUTE.DOCUMENTS_DOCUMENTS &&
                            location.pathname.startsWith(ROUTE.DOCUMENTS_INVOICES)) ||
                        (item.route === ROUTE.DOCUMENTS_DOCUMENTS &&
                            location.pathname.startsWith('/gds/')) ||
                        location.pathname.startsWith(item.route) ||
                        (item.route === ROUTE.DOCUMENTS_DOCUMENTS &&
                            location.pathname in EXTRA_ACTIVE_PATH_FOR_DOCUMENTS) ||
                        match
                    }
                    onClick={(e: any) => item.onClick?.(e) ?? onClickHandler(e)}
                >
                    <MenuIcon>{item.icon}</MenuIcon>
                    <MenuItemTitle>{item.title}</MenuItemTitle>
                </MenuItem>
            ))}
        </SidebarMenu>
    );
}
